import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview'
import VueClipboard from 'vue-clipboard2'
import 'iview/dist/styles/iview.css'
import '@style/common.less'
import store from './store'
import devComponents from '@components/index.js' // 自定义组件
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/effectScatter'
import VueCropper from 'vue-cropper'
// Map of China
import chinaMap from '@public/china.json'
import { Cascader, Calendar } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// registering map data
ECharts.registerMap('china', chinaMap)
// 注册chart组件
Vue.component('v-chart', ECharts)
// 剪裁图片组件
Vue.use(VueCropper)
// 挂载剪切板组件
Vue.use(VueClipboard)
// 挂载iview-ui组件
Vue.use(iView)
// 挂载自定义组件挂载
Vue.use(devComponents)
Vue.use(Cascader)
Vue.use(Calendar)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 扩展date 格式化方法d
Date.prototype.format = function(fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小写小时
    'H+': this.getHours(), // 大写小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

Vue.prototype.IsTest = () => {
  const hostUrl = window.location.href
  return hostUrl.indexOf('org.qupeiyin.com') == -1
}
